import { render, staticRenderFns } from "./GetMessagesText.vue?vue&type=template&id=46dfdcb1&"
import script from "./GetMessagesText.vue?vue&type=script&lang=js&"
export * from "./GetMessagesText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports